module.exports = __webpack_public_path__ + "static/img/4.aadeaa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/2/4.png
// module id = N9mV
// module chunks = 1